import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useContext } from '@nuxtjs/composition-api';
import type { DocumentItem } from '@webplatform/frontkit/dist/types';

interface Props {
  items?: DocumentItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductUserHelpDownloads',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { items: DocumentItem[] };



const { $config } = useContext();

const limit = ref(5);
const showAll = ref(false);
const visibleItems = computed(() =>
  showAll.value ? props.items : props.items?.slice(0, limit.value),
);
const hiddenItems = computed(() =>
  Math.max(0, (props.items?.length || 0) - limit.value),
);

const filterLink = (path: string) => {
  const isExternalLink = /^https?:/.test(path);

  if (isExternalLink) {
    return path;
  }

  return `${$config.fullPath}${path}`;
};

const showAllItems = () => {
  showAll.value = true;
};

return { __sfc: true,props, $config, limit, showAll, visibleItems, hiddenItems, filterLink, showAllItems }
}

})